import vue from "../main";
export default function(dateString) {
  if (dateString == null || dateString === "") return vue.$t("global.noData");
  let date = new Date(dateString);
  return ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear();
}
